/*
 * Created by jmeo at 2021-05-11
 * FileName: commonService.ts
 */

import API from '@src/constant/api'
import {ApplicantVo, ArchiveListItem, ListType, QualificationVo, UserVo} from '@src/type'
import request from '@util/request'

export default class CommonService {
	static login(u: string, p: string) {
		return request.post<UserVo>(API.URI_LOGIN, {
			phone: u,
			pwd: p,
		})
	}

	static logout() {
		return request.post(API.URI_LOGOUT)
	}

	/**
	 * 发送登录验证码
	 * @param phone
	 */
	static sendLoginCode(phone: string) {
		return request.post(API.URI_LOGIN_SEND_CODE, {phone})
	}

	/**
	 * 短信验证码登录
	 * @param phone
	 * @param code
	 */
	static codeLogin(phone: string, code: string) {
		return request.post(API.URI_LOGIN_CODE, {phone, yzm: code})
	}

	/**
	 * 修改密码发送短信验证码
	 * @param phone
	 */
	static sendPWDCode(phone: string) {
		return request.post(API.URI_PWD_SEND_CODE, {phone})
	}

	/**
	 * 修改密码短信验证码校验
	 * @param phone
	 * @param code
	 */
	static validatePWDCode(phone: string, code: string) {
		return request.post(API.URI_PWD_CODE_VALIDATE, {phone, yzm: code})
	}

	/**
	 * 修改密码
	 * @param pwd
	 */
	static changePwd(pwd: string) {
		return request.post(API.URI_PWD_CHANGE, {pwd})
	}

	static userDetail() {
		return request.post<UserVo>(API.URI_USER)
	}

	static qualificationList(param: any) {
		return request.get<ListType<QualificationVo>>(API.URI_QUALIFICATION, param)
	}

	static applyList(param: any) {
		return request.get<ListType<ApplicantVo>>(API.URI_APPLY, param)
	}

	static getCenterList(param: any) {
		return request.normalPost<ListType<any>>(API.CENTER_LIST, param)
	}

	static getQRContent() {
		return request.post(API.QR_CONTENT)
	}

	// 获取客户留资列表
	static getPreloanList(param: any) {
		return request.get<ListType<any>>(API.PRELOAN_LIST, param)
	}

	// 获取人员列表
	static getAsignManageList(param: any) {
		return request.get(API.ASIGN_MANAGE_LIST, param)
	}

	// 获取人员列表
	static intensionAsign(param: any) {
		return request.post(API.INTENSION_ASIGN, param)
	}

	// 客户留资标记
	static contackMark(param: any) {
		return request.get(API.CONTACK_MARK, param)
	}

	// 客户留资标记
	static editStatus(param: any) {
		return request.normalPost(API.EDIT_STATUS, param)
	}

	// 客户留资标记
	static getPlanDetail(param: any) {
		return request.post(API.PLAN_DETAIL, param)
	}

	// 获取手续费率
	static getConfig() {
		return request.get(API.GET_CONFIG)
	}

	// 获取车型
	static getCareList(param: any) {
		return request.post(API.GET_CARE_LIST, param)
	}

	// 获取省市
	static getArealist() {
		return request.post(API.GET_CITYS)
	}

	// 计算方案
	static planCale(params: any) {
		return request.normalPost(API.PLAN_CALE, params)
	}

	// 确认下发
	static confirmCreate(params: any) {
		return request.normalPost(API.CONFIRM_CREATE, params)
	}

	// 编辑下发
	static confirmEdit(params: any) {
		return request.normalPost(API.CONFIRM_EDIT, params)
	}

	// 合同详情
	static getContrackDetail(params: any) {
		return request.post(API.CONTRACK_DETAIL, params)
	}

	// 上传图片
	static uploadImage(params: any) {
		return request.post(API.UPLOAD_IMG, params)
	}

	// 放贷详情
	static getApplyDetail(params: any) {
		return request.post(API.APPLY_DETAIL, params)
	}

	// 放贷提交
	static applyCommit(params: any) {
		return request.normalPost(API.APPLY_COMMIT, params)
	}

	// 合同推送
	static pushContrack(params: any) {
		return request.post(API.PUSH_CONTRACT, params)
	}

	// 资格指派
	static asignByDealerManager(params: any) {
		return request.get(API.ZI_GE_ASIGN, params)
	}

	static getArchiveList(params: any) {
		return request.post<ListType<ArchiveListItem>>(API.ARCHIVE_LIST, params)
	}

	static getArchiveDetail(id: number) {
		return request.post<any>(API.ARCHIVE_LIST_ITEM_DETAIL, {id})
	}

	static archiveSave(param: any) {
		return request.post<any>(API.ARCHIVE_FORM_SAVE, param)
	}

	static archiveSubmit(param: any) {
		return request.post(API.ARCHIVE_FORM_SUBMIT, param)
	}

	static holidayValidate(){
		return request.axios.get(API.API_HOLIDAY_VALIDATE)
	}

	static getAllOrders(param: any) {
		return request.normalPost(API.URI_ALL_LIST, param)
	}
}
